import { Directive, Input, TemplateRef, ViewContainerRef, inject } from '@angular/core';
import { LoginService } from '../../login.service';
import { RoleGroup } from '../authorization/roles';

@Directive({
  selector: '[appHasRole]',
  standalone: true,
})
export class HasRoleDirective {
  private readonly loginService = inject(LoginService);
  private readonly templateRef = inject(TemplateRef<unknown>);
  private readonly viewContainer = inject(ViewContainerRef);
  private allowedRoles: RoleGroup = [];
  private condition = true;
  private rendered = false;

  @Input()
  set appHasRole(allowedRoles: RoleGroup) {
    this.allowedRoles = allowedRoles;
    this.updateView();
  }

  @Input()
  set appHasRoleWhen(condition: boolean) {
    this.condition = condition;
    this.updateView();
  }

  private updateView(): void {
    const shouldRender = this.condition &&
      this.loginService.hasAnyRole(this.allowedRoles);

    if (shouldRender && !this.rendered) {
      this.viewContainer.createEmbeddedView(this.templateRef);
      this.rendered = true;
      return;
    }

    if (!shouldRender && this.rendered) {
      this.viewContainer.clear();
      this.rendered = false;
    }
  }
}
